import { useContext } from "react";
import { RequestScreenContext } from "../contexts/RequestScreenContext";

export function useForm27RequestScreenContext() {
  const c = useContext(RequestScreenContext);
  return c;
}